/** @jsx jsx */
import _ from 'lodash'
import React, { useState, useEffect } from 'react'
import { jsx, Flex, Box } from 'theme-ui'
import { useInterval } from 'react-use'
import {
  pokerChipValues,
  PokerChip,
  PokerChipValue,
  UnassignedPokerChip,
  pokerChipValueToBgColorMap,
} from './PokerChip'
import { SEOProps, SEO } from './SEO'

const RandomChip: React.SFC<{
  amount: PokerChipValue
  count: number
}> = ({ amount, count, ...props }) => {
  return (
    <Box
      css={{
        position: 'relative',
        display: 'inline-block',
        width: 30,
        height: 100,
      }}
      {...props}
    >
      {_.times(count).map((_, chipIndex) => (
        <UnassignedPokerChip
          formattedNumber="$"
          backgroundColor={pokerChipValueToBgColorMap[amount]}
          key={chipIndex}
          height={30}
          css={{
            position: 'absolute',
            top: (10 - chipIndex - 0) * 3,
          }}
        />
      ))}
    </Box>
  )
}

const ChipsStacking: React.SFC<{}> = () => {
  const [{ count }, setCount] = useState({ count: 1, direction: 'up' as 'up' | 'down' })
  const chipStacks = 8
  useInterval(() => {
    setCount((state) => ({
      count: state.count + (state.direction === 'up' ? 1 : -1),
      direction: state.count > 7 ? 'down' : state.count < 2 ? 'up' : state.direction,
    }))
  }, 150)
  const percentage = count / chipStacks
  const counts = _.times(8).map((_, index) => {
    const countPercentage = (index + 1) / chipStacks
    return Math.floor(20 - 19 * Math.abs(percentage - countPercentage))
  })
  return (
    <Box>
      {pokerChipValues.slice(0, chipStacks).map((val, index) => (
        <RandomChip count={counts[index]} amount={val} key={val} sx={{ ml: index ? 3 : 0 }} />
      ))}
    </Box>
  )
}

const _LoadingPage: React.SFC<SEOProps> = (props) => {
  return (
    <Flex sx={{ justifyContent: 'center', alignItems: 'center', height: '100vh', width: '100vw' }}>
      <SEO {...props} />
      <ChipsStacking />
    </Flex>
  )
}

export const LoadingPage = React.memo(_LoadingPage)
